export default "__VITE_ASSET__T8In0w8G__"